export const CONNECTOR_ERRORS = {
  CONNECTOR_INVALID: 'CONNECTOR_INVALID',
  FETCH_RESULTS_ERROR: 'FETCH_RESULTS_ERROR',
};

export const createBaseConnectorClass = () =>
  class BaseConnectorClass {
    constructor(getAttribute) {
      this.getAttribute = getAttribute;
      this.isValid = this.#validateConfig();
    }

    checkConnectorValidity() {
      this.isValid = this.#validateConfig();
    }

    #validateConfig() {
      const missingOrInvalidParams = this.getRequiredParams().filter(
        (param) => {
          const value = this.getAttribute(param);
          return !value || !this.validateParam(param, value);
        },
      );

      if (missingOrInvalidParams.length) {
        return false;
      }
      return true;
    }

    // eslint-disable-next-line class-methods-use-this
    validateParam(param, value) {
      // Base validation - can be overridden by specific connectors
      return value.trim().length > 0;
    }

    // eslint-disable-next-line class-methods-use-this
    getRequiredParams() {
      // eslint-disable-next-line no-console
      console.error('Connector must implement getRequiredParams');
      return [];
    }

    async fetch(query) {
      if (!this.isValid) {
        // eslint-disable-next-line no-console
        console.error(
          `[${this.constructor.name}] Cannot fetch results: connector is not properly configured`,
        );
        return { results: [], error: CONNECTOR_ERRORS.CONNECTOR_INVALID };
      }

      return this._fetchResults(query);
    }

    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    _fetchResults(query) {
      // eslint-disable-next-line no-console
      console.error('Connector must implement fetchResults');
      return { results: [], error: undefined };
    }
  };
